"use client";

import FormSelectField from "@/components/custom-form/FormSelectField";
import type { SearchModuleFormValues } from "../search.modules.type";
import type { Control } from "react-hook-form";
import { memo } from "react";
import { pickUpTimeOptions, vehicleTypeOptions } from "../search.modules.type";

type RentalFieldsProps = {
  control: Control<SearchModuleFormValues>;
  disableVehicleType?: boolean;
  disablePickupType?: boolean;
  onVehicleTypeChange?: (value: string) => void;
  onPickupTypeChange?: (value: string) => void;
  useInlineFieldExpansion?: boolean;
  activeInlineField?: string | null;
  onInlineExpandedChange?: (field: "vehicleType" | "pickupType" | null) => void;
};

const RentalFields = ({
  control,
  disableVehicleType,
  disablePickupType,
  onVehicleTypeChange,
  onPickupTypeChange,
  useInlineFieldExpansion = false,
  activeInlineField,
  onInlineExpandedChange,
}: RentalFieldsProps) => {
  return (
    <>
      <div className="flex-1 min-w-0">
        <FormSelectField
          name="vehicleType"
          control={control}
          title="Select Vehicle Type"
          placeholder="Vehicle type"
          options={vehicleTypeOptions}
          disabled={disableVehicleType}
          onChange={onVehicleTypeChange}
          inlineExpanded={
            useInlineFieldExpansion && activeInlineField === "vehicleType"
          }
          onInlineExpandedChange={
            useInlineFieldExpansion
              ? (open) => onInlineExpandedChange?.(open ? "vehicleType" : null)
              : undefined
          }
        />
      </div>

      <div className="flex-1 min-w-0">
        <FormSelectField
          name="pickupType"
          control={control}
          title="Select Pick-up Time (Optional)"
          placeholder="Pick-up time (Optional)"
          options={pickUpTimeOptions}
          disabled={disablePickupType}
          onChange={onPickupTypeChange}
          inlineExpanded={
            useInlineFieldExpansion && activeInlineField === "pickupType"
          }
          onInlineExpandedChange={
            useInlineFieldExpansion
              ? (open) => onInlineExpandedChange?.(open ? "pickupType" : null)
              : undefined
          }
        />
      </div>
    </>
  );
};

export default memo(RentalFields);
